import i18n from 'i18next'
import Yup from "../../../services/common/validation"
import { regExText, regExTextPlace, regExTextStreet, regExTextStreetNumber, regExTextZipCode, VALIDATION_ERRORS } from "../PersonalDetails/validation-schema"
import { ValidTypeEntered } from '../../../models/enums'

export const getValidationSchema = () => {
  return Yup.object().shape({
      customerData: Yup.object().shape({
        deliveryAddress: Yup.object().when('deliveryAddressActive',
          // eslint-disable-next-line no-negated-condition
          (deliveryAddressActive, schema) => !!deliveryAddressActive
            ? schema.shape({
              deviatingFirstName: Yup.string()
                .matches(regExText, VALIDATION_ERRORS.valueInvalid(ValidTypeEntered.LETTERS))
                .min(2, i18n.t('validation:minLength', { value: 2 }))
                .max(35, i18n.t('validation:maxLength', { value: 35 }))
                .required(VALIDATION_ERRORS.inputRequired(i18n.t('personal-details:lastName'))),
              deviatingLastName: Yup.string()
                .matches(regExText, VALIDATION_ERRORS.valueInvalid(ValidTypeEntered.LETTERS))
                .min(2, i18n.t('validation:minLength', { value: 2 }))
                .max(35, i18n.t('validation:maxLength', { value: 35 }))
                .required(VALIDATION_ERRORS.inputRequired(i18n.t('personal-details:lastName'))),
              street: Yup.string()
                .required(VALIDATION_ERRORS.inputRequired(i18n.t('personal-details:street')))
                .matches(regExTextStreet, i18n.t('validation:invalidCharacter'))
                .min(2, i18n.t('validation:minLength', { value: 2 }))
                .max(60, i18n.t('validation:maxLength', { value: 60 })),
              houseNumber: Yup.string()
                .required(VALIDATION_ERRORS.inputRequired(i18n.t('personal-details:houseNumber')))
                .matches(regExTextStreetNumber, i18n.t('validation:invalidCharacter'))
                .min(1, i18n.t('validation:minLength', { value: 1 }))
                .max(10, i18n.t('validation:maxLength', { value: 10 })),
              zipCode: Yup.string()
                .required(VALIDATION_ERRORS.inputRequired(i18n.t('personal-details:zipCode')))
                .matches(regExTextZipCode, i18n.t('validation:invalidCharacter'))
                .min(3, i18n.t('validation:minLength', { value: 3 }))
                .max(10, i18n.t('validation:maxLength', { value: 10 })),
              city: Yup.string()
                .required(VALIDATION_ERRORS.inputRequired(i18n.t('personal-details:city')))
                .matches(regExTextPlace, VALIDATION_ERRORS.valueInvalid(ValidTypeEntered.LETTERS))
                .min(2, i18n.t('validation:minLength', { value: 2 }))
                .max(35, i18n.t('validation:maxLength', { value: 35 })),
              countryCode: Yup.string().test(
                'my-test-name',
                VALIDATION_ERRORS.inputRequired(i18n.t('personal-details:countryCode')),
                (value) => value !== 'NONE'
              ),
            })
            : schema
          )
      })
    })
}